// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kjrQ","footer":"styles_footer__a0zmr","passCodeTooltip":"styles_passCodeTooltip__AkDe2"};